import React from 'react';
import { useDataContext } from '../context/DataContext';

const FilterToggle = () => {
  const { setShowFilters } = useDataContext();

  return (
    <div className="text-center visuallyhidden--desk">
      <button type="button" className="button" onClick={() => setShowFilters(true)}>Meer filters toepassen</button>
    </div>
  );
};

export default FilterToggle;
